<template>
  <div
    :dir="layoutDir"
    class="mx-auto flex min-h-screen flex-col bg-[#0d0f15] text-white"
  >
    <header class="relative z-10 h-20 border-b border-white/5 bg-[#0d0f15]">
      <div
        class="mx-auto flex h-full max-w-5xl items-center justify-between px-4"
      >
        <div class="text-2xl font-black tracking-tight text-white">
          <img
                        src="@/assets/nasna-logo-bok.svg"

            alt="nasna-logo"
            class="h-8 w-auto object-cover"
          />
        </div>

        <InitHeader
          :currentLanguage="currentLanguage"
          @language-changed="setLanguage"
        />
      </div>
    </header>

    <main class="relative flex-1 border-b border-white/5">
      <!-- <div
        class="pointer-events-none absolute inset-x-0 top-0 h-[270px] opacity-20"
        style="
          background-image: repeating-linear-gradient(
            120deg,
            transparent 0px,
            transparent 7px,
            #686b78 8px,
            transparent 12px
          );
        "
      ></div> -->

             <auth-carsouel />
     

    
      <div class="relative mx-auto max-w-5xl px-4 pb-10 pt-10">
        <section
          class="mx-auto max-w-3xl rounded-xl border border-[#343743] bg-[#17191f]/95 p-4 shadow-2xl sm:p-6 md:p-8"
        >
          <div class="flex flex-col justify-center items-center">
            <img
                         src="@/assets/nasna-logo-bok.svg"

              alt="nasna-logo"
              class="h-8 w-auto object-cover"
            />

            <p
              class="mx-auto mt-3 max-w-lg text-xs leading-6 text-gray-400 sm:text-sm"
            >
              {{ t.heroDescription }}
            </p>
          </div>

          <div class="mt-5 flex justify-center" dir="ltr">
            <div class="relative flex rounded-full bg-[#20222b] p-1">
              <span
                class="absolute -top-2 right-1 rounded-full bg-[#8ee7bd] px-2 py-0.5 text-[9px] font-bold text-[#111]"
              >
                {{ t.discount }}
              </span>

              <button
                type="button"
                @click="selectBilling('weekly')"
                :class="[
                  'rounded-full px-7 py-2 text-sm transition',
                  selectedBilling === 'weekly'
                    ? 'bg-[#d0b45e] font-bold text-[#17181d]'
                    : 'text-gray-400',
                ]"
              >
                {{ t.weekly }}
              </button>

              <button
                type="button"
                @click="selectBilling('monthly')"
                :class="[
                  'rounded-full px-7 py-2 text-sm transition',
                  selectedBilling === 'monthly'
                    ? 'bg-[#d0b45e] font-bold text-[#17181d]'
                    : 'text-gray-400',
                ]"
              >
                {{ t.monthly }}
              </button>
            </div>
          </div>

          <div
            class="mt-7 flex items-center justify-between gap-2 border-b border-white/10 pb-4"
          >
            <div
              class="text-right"
              :class="isArabic ? 'text-right' : 'text-left'"
            >
              <h2 class="text-xl font-bold">
                {{ t.priceTitle }}
              </h2>

              <p class="text-xs text-gray-500">
                {{ t.vatLabel }}
              </p>
            </div>

            <div class="text-left" dir="ltr">
              <div class="text-2xl font-bold">
                {{ formattedPrice }}
              </div>

              <p class="text-xs text-gray-500">
                {{
                  selectedBilling === "monthly" ? t.monthlyLabel : t.weeklyLabel
                }}
              </p>
            </div>
          </div>

          <div class="mt-4 space-y-3 text-sm text-gray-300 hidden">
            <div
              class="flex items-center gap-2"
              v-for="benefit in t.benefits"
              :key="benefit"
            >
              <span
                class="flex h-4 w-4 items-center justify-center rounded-full bg-[#d0b45e] text-[10px] text-[#17181d]"
              >
                ✓
              </span>

              <span>
                {{ benefit }}
              </span>
            </div>
          </div>

          <form class="mt-5 space-y-4" @submit.prevent="submit">
            <div>
              <label for="phone" class="mb-2 block text-sm text-gray-400">
                {{ t.phoneLabel }}
              </label>

              <div
                dir="ltr"
                class="flex overflow-hidden rounded-lg border border-[#343743] bg-[#1d1f28] focus-within:border-[#d0b45e]"
              >
                <div
                  class="flex items-center border-r border-[#343743] px-3 text-sm text-gray-400"
                >
                  +249
                </div>

                <input
                  id="phone"
                  v-model="phone"
                  type="tel"
                  :placeholder="t.phonePlaceholder"
                  maxlength="9"
                  class="w-full rounded-lg bg-transparent px-4 py-4 text-sm text-white outline-none focus:border-transparent focus:outline-none focus:ring-0 focus:ring-transparent focus:shadow-none placeholder:text-gray-600"
                  @input="sanitizePhone"
                />
              </div>
            </div>

            <div>
              <label for="cif" class="mb-2 block text-sm text-gray-400">
                {{ t.cifLabel }}
              </label>

              <div
                dir="ltr"
                class="flex overflow-hidden rounded-lg border border-[#343743] bg-[#1d1f28] focus-within:border-[#d0b45e]"
              >
                <div
                  class="flex items-center px-3 text-xs font-bold text-[#d0b45e]"
                >
                  {{ t.bankak }}
                </div>

                <input
                  id="cif"
                  v-model="cif"
                  type="text"
                  placeholder="1234567"
                  maxlength="7"
                  class="w-full rounded-lg bg-transparent px-4 py-4 text-sm text-white outline-none focus:border-transparent focus:outline-none focus:ring-0 focus:ring-transparent focus:shadow-none placeholder:text-gray-600"
                  @input="sanitizeCif"
                />
              </div>
            </div>

            <button
              type="submit"
              :disabled="!validateForm || isSubmitting"
              class="w-full rounded-lg py-3.5 text-sm font-bold transition active:scale-[0.99]"
              :class="
                validateForm && !isSubmitting
                  ? 'bg-[#d0b45e] text-[#17181d] hover:bg-[#dec46e]'
                  : 'cursor-not-allowed bg-[#7f7344] text-[#1b1d22]'
              "
            >
              {{ isSubmitting ? t.submitting : t.subscribeNow }}
            </button>
          </form>

          <div
            class="mt-4 flex flex-col-reverse gap-3 text-[10px] text-gray-500 sm:flex-row sm:items-center sm:justify-between"
          >
            <div
              class="flex md:w-36 w-16 items-center justify-center rounded-full text-xs font-bold"
            >
              <img src="@/assets/payments/bok.png" alt="bok-logo" class="object-cover" />
            </div>

            <p :class="isArabic ? 'text-right' : 'text-left'">
              {{ t.agreementText }}
              <a
                href="https://sites.google.com/view/nasnatv"
                class="text-[#d0b45e] hover:text-[#dec46e]"
                >{{ t.terms }}</a
              >
              {{ t.and }}
              <a
                href="https://sites.google.com/view/nasna-tv"
                class="text-[#d0b45e] hover:text-[#dec46e]"
                >{{ t.privacy }}</a
              >
            </p>
          </div>
        </section>

        <section
          class="mx-auto mt-5 grid max-w-3xl grid-cols-1 gap-3 sm:grid-cols-3"
        >
          <div
            v-for="feature in t.features"
            :key="feature.title"
            class="rounded-xl border border-white/5 bg-[#171920]/90 p-5 text-center"
          >
            <div class="mx-auto mb-4 h-8 w-8 rounded-lg " v-html="feature.icon">
              
            </div>

            <h3 class="font-bold">
              {{ feature.title }}
            </h3>

            <p class="mt-2 text-xs leading-5 text-gray-500">
              {{ feature.description }}
            </p>
          </div>
        </section>
      </div>

      <bok-footer
        :currentLanguage="currentLanguage"
        :isArabic="isArabic"
        :t="t"
      />
    </main>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useBokStore } from "@/stores/bok";
import InitHeader from "@/components/bok/InitHeader.vue";
import BokFooter from "@/components/bok/BokFooter.vue";
import { initTrs } from "../../../bok.trs";
import { useToast } from "vue-toastification";
import AuthCarsouel from "@/components/shared/AuthCarsouel.vue"
import { USER } from "@/constants";
export default {
  components: {
    InitHeader,
    BokFooter,
    AuthCarsouel,
  },
  data() {
    return {
      phone: "",
      selectedBilling: "",
      selectedPlan: "",
      cif: "",
      currentLanguage: localStorage.getItem("lang-bok") || "ar",

      isSubmitting: false,
      translations: initTrs,

      toast: useToast(), // Assuming you have a toast plugin or method available
    };
  },
  computed: {
    ...mapState(useBokStore, ["getPlans"]),
    plans() {
      if (Array.isArray(this.getPlans)) {
        return this.getPlans;
      }

      if (Array.isArray(this.getPlans?.data)) {
        return this.getPlans.data;
      }

      return [];
    },
    t() {
      return this.translations[this.currentLanguage] || this.translations.ar;
    },
    isArabic() {
      return this.currentLanguage === "ar";
    },
    layoutDir() {
      return this.isArabic ? "rtl" : "ltr";
    },
    validateForm() {
      return (
        this.phone.length === 9 &&
        this.cif.length === 7 &&
        Boolean(this.selectedPlan)
      );
    },
    activePlan() {
      return this.plans.find((plan) => plan.plan_uuid === this.selectedPlan);
    },
    formattedPrice() {
      const fallback = "9,800.00";
      if (!this.activePlan) {
        return fallback;
      }

      const rawPrice =
        this.activePlan.price ??
        this.activePlan.amount ??
        this.activePlan.final_price;
      const numericPrice = Number(rawPrice);
      if (Number.isNaN(numericPrice)) {
        return String(rawPrice || fallback);
      }

      return numericPrice.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
  methods: {
    ...mapActions(useBokStore, ["initPayment", "fetchPlans"]),
    createIdempotencyKey(prefix = "bok") {
      const randomUuid =
        typeof window !== "undefined" &&
        window.crypto &&
        typeof window.crypto.randomUUID === "function"
          ? window.crypto.randomUUID()
          : null;

      if (randomUuid) {
        return `${prefix}-${randomUuid}`;
      }

      return `${prefix}-${Date.now()}-${Math.random()
        .toString(36)
        .slice(2, 10)}`;
    },
    getBokIdempotencyStorageKeys() {
      return {
        INIT: "bok-idempotency-init",
      };
    },
    setLanguage(language) {
      this.currentLanguage = language;
      localStorage.setItem("lang-bok", language);
    },
    sanitizePhone() {
      this.phone = this.phone.replace(/\D/g, "").slice(0, 9);
    },

    sanitizeCif() {
      this.cif = this.cif.replace(/\D/g, "").slice(0, 7);
    },
    detectPlanType(plan) {
      return plan.name.toLowerCase().includes("weekly")
        ? "weekly"
        : plan.name.toLowerCase().includes("monthly")
        ? "monthly"
        : null;
    },
    findPlanByBilling(billing) {
      return (
        this.plans.find((plan) => this.detectPlanType(plan) === billing) || null
      );
    },
    selectBilling(billing) {
      this.selectedBilling = billing;
      const matchingPlan = this.findPlanByBilling(billing);
      if (matchingPlan) {
        this.selectedPlan = matchingPlan.plan_uuid;
      }
    },
    setupDefaultPlan() {
      if (this.plans.length === 0) {
        this.selectedPlan = "";
        this.selectedBilling = "";
        return;
      }

      const preferredPlan =
        this.findPlanByBilling("monthly") ||
        this.findPlanByBilling("weekly") ||
        this.plans[0];

      this.selectedPlan = preferredPlan.plan_uuid;
      this.selectedBilling = this.detectPlanType(preferredPlan) || "weekly";
    },
    checkAuthentication() {
      const userData = localStorage.getItem(USER);
      if (!userData) {
        this.toast.error(this.t.authError);
        this.$router.push("/auth/login");
        return false;
      }
      return true;
    },
    getPaymentErrorMessage(error) {
      const data = error?.response?.data || error?.data || error || {};
      const message =
        typeof data.message === "string" ? data.message.trim() : "";
      const locale = this.currentLanguage.toLowerCase().startsWith("en")
        ? "en"
        : "ar";
      const paymentErrors = this.translations[locale].paymentErrors;

      if (message.includes("Please enable Ecommerce on Bankak")) {
        return paymentErrors.BOK_ECOMMERCE_DISABLED;
      }

      const translatedMessage = paymentErrors[data.errorCode?.trim()];

      return translatedMessage || message || this.translations[locale].paymentError;
    },
    async submit() {
      if (!this.validateForm || this.isSubmitting) {
        console.log("Form validation failed or already submitting.");
        return;
      }
      const res = this.checkAuthentication();
      if (!res) {
        return;
      }
      localStorage.setItem("phone-bok", `249${this.phone}`);
      localStorage.setItem("cif-bok", this.cif);
      localStorage.setItem("bok-price", this.formattedPrice);
      localStorage.setItem("bok-plan-uuid", this.selectedPlan);

      const payload = {
        cif: this.cif,
        plan_uuid: this.selectedPlan,
        mobile: `249${this.phone}`,
      };

      const keyStorage = this.getBokIdempotencyStorageKeys();
      const initIdempotencyKey =
        localStorage.getItem(keyStorage.INIT) ||
        this.createIdempotencyKey("bok-init-flow");
      localStorage.setItem(keyStorage.INIT, initIdempotencyKey);

      try {
        this.isSubmitting = true;
        const response = await this.initPayment(payload, {
          idempotencyKey: initIdempotencyKey,
        });
        if (response.data.success) {
          this.$router.push("/bok/verify-subscription");
        } else {
          console.error("Error:", response);
          this.toast.error(this.getPaymentErrorMessage(response));
        }
      } catch (error) {
        console.error("Error initiating Bankak payment:", error);
        this.toast.error(this.getPaymentErrorMessage(error));
      } finally {
        this.isSubmitting = false;
      }
    },
  },
  async created() {
    await this.fetchPlans();
    this.setupDefaultPlan();
  },
  watch: {
    getPlans: {
      deep: true,
      handler() {
        if (!this.selectedPlan) {
          this.setupDefaultPlan();
        }
      },
    },
  },
};
</script>

<style >
</style>
